import { Wrapper } from "../../theme/GlobalStyle";
import { BootstrapModal } from "../BootstrapModal/Modal";
import Button from "../Button/Button";
import { CgClose } from "react-icons/cg";
import { InputField1 } from "../InputField1/InputField1";
import Editor from "../../core/components/textEditor/Editor";
import styled from "styled-components";
import { useGetTemplateTextTable } from "../../hooks/useContent";
import { Table } from "../Table/Table";
import Loading from "../../components/Loadings/LoadingTable";

const ShareTelegramDialog = ({
  show,
  handleClose,
  title,
  setForm,
  form,
  successHandler,
}) => {
  const { data, isLoading, isError } = useGetTemplateTextTable();

  const handleSelectText = (text) => {
    setForm(text);
  };

  const items = data ? (
    data?.data?.Templates?.map((item, index) => {
      return (
        <tr key={index}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {index + 1}
            </span>
          </td>
          <td>
            <span
              onClick={(e) => handleSelectText(item?.ContentTemplate)}
              className="text-muted fw-bold text-muted d-block fs-7"
            >
              {item?.NameTemplate ? item?.NameTemplate : ""}
            </span>
          </td>
          <td>
            <span
              onClick={(e) => handleSelectText(item?.ContentTemplate)}
              className="text-muted fw-bold text-muted d-block fs-7"
            >
              {item?.ContentTemplate
                ? item?.ContentTemplate.length > 30
                  ? item?.ContentTemplate.slice(0, 30) + " ..."
                  : item?.ContentTemplate
                : ""}
            </span>
          </td>
        </tr>
      );
    })
  ) : (
    <Loading />
  );

  const pageCount = 0;

  const headerTitle = ["#", "نام", "محتوا"];

  //  const Templates

  return (
    <BootstrapModal
      modaltitle={title}
      handleClose={handleClose}
      show={show}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <FormContol>
        <TextArea
          value={form}
          placeholder="توضیحات"
          onChange={(event) => setForm(event.target.value)}
        ></TextArea>
        <TableContainer>
          <Table
            noSearch={true}
            headerTitle={headerTitle}
            title={`دسته بندی هایی که تاکنون ثبت شده اند`}
            items={items}
          />
        </TableContainer>
      </FormContol>
      <Wrapper>
        <Button
          color="#fff"
          bgColor="#28A745"
          small
          size="14px"
          spaceLeft=".5rem"
          onclick={successHandler}
        >
          ارسال
        </Button>
        <Button
          bgColor="#0D6EFD"
          color="#fff"
          small
          size="14px"
          onclick={handleClose}
        >
          منصرف شدم
        </Button>
      </Wrapper>
    </BootstrapModal>
  );
};

const FormContol = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const TextArea = styled.textarea`
  background-color: ${({ theme }) => theme.body};
  color: ${({ theme }) => theme.text};
  height: 150px;
  border: 1px solid ${({ theme }) => theme.borderLight};
  outline: none;
  font-size: 14px;
  padding: 0.5rem;
`;

const TableContainer = styled.div`
  margin-top: 1rem;
`;

export default ShareTelegramDialog;
